// Components
import speechBubble from '../../../_img/icons/icon-speech-bubble.svg';
import Popper from 'vue-popperjs';

// Scss
import './tooltip.scss';

// Template and media files
import template from './tooltip.vhtml';

export default {
	template: template,
	components: {
		Popper,
		speechBubble,
	},
	props: {
		title: {
			type: String,
			required: true,
		},
		expl: {
			type: String,
			required: true,
		}
	},
	data: () => ({
		termIsInitialized: false,
		popperOptions: {
			placement: 'bottom',
		},
	}),
	methods: {
		closePopup() {
			this.$refs.popper.doClose();
		},
	},
	mounted() {
		this.termIsInitialized = this.$store.getters['dictionary/isTermInitialized'](this.title);
		if(!this.termIsInitialized) {
			this.$store.commit('dictionary/initializeTerm', this.title);
		}
	}
};


// WEBPACK FOOTER //
// ./assets/_js/components/tooltip/tooltip.js